import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isValidYear',
  pure: true,
  standalone: true,
})
export class IsValidYearPipe implements PipeTransform {
  transform(year: any): boolean {
    return year && year != 0 && year.toString().length >= 4;
  }
}
